import { render, staticRenderFns } from "./PopularProductMobile.vue?vue&type=template&id=a7799e46&scoped=true"
import script from "./PopularProductMobile.vue?vue&type=script&lang=js"
export * from "./PopularProductMobile.vue?vue&type=script&lang=js"
import style0 from "./PopularProductMobile.vue?vue&type=style&index=0&id=a7799e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7799e46",
  null
  
)

export default component.exports